import React, { useEffect, useState } from 'react';
import { statsService } from '../services/api';
import OverviewCards from '../components/stats/OverviewCards';
import GovernoratesChart from '../components/stats/GovernoratesChart';
import TrendChart from '../components/stats/TrendChart';
import CategoryBreakdown from '../components/stats/CategoryBreakdown';
import ParticipantsStats from '../components/stats/ParticipantsStats';
import DayOfWeekHeatmap from '../components/stats/DayOfWeekHeatmap';
import ActiveRegionsStats from '../components/stats/ActiveRegionsStats';
import WordCloud from '../components/stats/WordCloud';
import UserActivity from '../components/stats/UserActivity';
import DataQualityScore from '../components/stats/DataQualityScore';
import GovernorateHeatmap from '../components/stats/GovernorateHeatmap';
import SyriaProtestMap from '../components/stats/SyriaProtestMap';
import PoliticalOrientationChart from '../components/stats/PoliticalOrientationChart';
import styles from './StatisticsDashboard.module.css';

export default function StatisticsDashboard() {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => { loadStats(); }, []);

    const loadStats = async () => {
        try {
            setLoading(true);
            setError(null);
            const res = await statsService.comprehensive();
            setStats(res.data);
        } catch (err) {
            setError('فشل تحميل الإحصائيات');
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className={styles.loading}>جاري تحميل الإحصائيات...</div>;
    if (error)   return <div className={styles.error}>{error} <button onClick={loadStats}>إعادة المحاولة</button></div>;
    if (!stats)  return null;

    return (
        <div className={`${styles.container} text-ar`}>
            <div className={styles.header}>
                <h1>لوحة الإحصائيات الشاملة</h1>
                <button className={styles.refreshBtn} onClick={loadStats}>↺ تحديث</button>
            </div>

            <section className={styles.section}>
                <OverviewCards data={stats.overview} />
            </section>

            <div className={styles.grid2}>
                <section className={styles.section}>
                    <h2>الاتجاه العام — آخر 30 يوم</h2>
                    <TrendChart data={stats.trend} />
                </section>
                <section className={styles.section}>
                    <h2>أعلى 5 محافظات نشاطاً</h2>
                    <GovernoratesChart data={stats.top_governorates} />
                </section>
            </div>

            <div className={styles.grid2}>
                <section className={styles.section}>
                    <h2>توزيع التصنيفات</h2>
                    <CategoryBreakdown data={stats.categories} />
                </section>
                <section className={styles.section}>
                    <h2>الأنشطة حسب أيام الأسبوع</h2>
                    <DayOfWeekHeatmap data={stats.day_of_week} />
                </section>
            </div>

            <section className={styles.section}>
                <h2>إحصائيات المشاركين</h2>
                <ParticipantsStats data={stats.participants} />
            </section>

            <section className={styles.section}>
                <h2>نشاط المحافظات</h2>
                <ActiveRegionsStats data={stats.active_regions} />
            </section>

            <section className={styles.section}>
                <h2>الخريطة الجغرافية — كثافة الاحتجاجات</h2>
                <SyriaProtestMap data={stats.active_regions} />
            </section>

            <section className={styles.section}>
                <h2>خريطة حرارية — الاحتجاجات حسب المحافظة والأسبوع</h2>
                <GovernorateHeatmap data={stats.governorate_heatmap} />
            </section>

            <section className={styles.section}>
                <h2>التصنيفات الفرعية الأكثر نشاطاً</h2>
                <WordCloud data={stats.top_demands} />
            </section>

            {stats.political_orientation?.length > 0 && (
                <section className={styles.section}>
                    <h2>التوجهات السياسية للاحتجاجات</h2>
                    <PoliticalOrientationChart data={stats.political_orientation} />
                </section>
            )}

            <div className={styles.grid2}>
                <section className={styles.section}>
                    <h2>نشاط المستخدمين</h2>
                    <UserActivity data={stats.user_activity} />
                </section>
                <section className={styles.section}>
                    <h2>جودة البيانات</h2>
                    <DataQualityScore data={stats.data_quality} />
                </section>
            </div>
        </div>
    );
}
